export const TITLE_DEFAULT =
  'Parcelamento em até 24x sem juros para negociar dívidas?'
